import { IsIn } from 'class-validator';

export const SUPPORTED_LANGUAGES = ['fr-FR', 'en-US', 'de-DE'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export class LanguageDto {
  @IsIn(SUPPORTED_LANGUAGES)
  language!: SupportedLanguage;
}
